<template>
  <el-container>
    <div v-if="common.isMobile() === false">
      <publicHeader ref="child"></publicHeader>
    </div>
    <div v-else>
      <div style="height: 60px; background-color: rgba(79, 76, 76, 1)">
        <i class="el-icon-arrow-left" style=" color: white; height: 20px; width: 20px; font-size: 20px; position: absolute; margin: 20px 0px 20px 20px;" @click="goback()"></i>
        <div
          style="
            font-weight: 650;
            font-style: normal;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            height: 60px;
            line-height: 60px;
          "
        >
          {{ $t("refundPolicy") }}
        </div>
      </div>
    </div>
    <el-main :class="{ 'top-pc': common.isMobile() === false }">
      <div class="policy-main" v-if="common.languageSet() === 'en'">
          <div class="policy-title" v-if="common.isMobile() === false">Refund Policy</div>
          <div class="policy-content">
            <span>To request a refund, please contact us through any of the following methods:</span>
            <span>
              • Apply on our website
              <router-link :to="weburl">
                {{ webhost }}
              </router-link>
              <!-- <a v-bind:href="weburl">{{ webhost }}</a> -->
            </span>
            <span>• Call us at [+86-411-84949566] (international call charges apply)</span>
            <span>
              • Send an email via our
              <router-link :to="contactUsUrl">
                {{ webhost }}
              </router-link>
              <!-- <a v-bind:href="contactUsUrl">customer support</a> -->
              page
            </span>
            <span>LETSFLY LIMITED is committed to providing you with a straightforward and efficient refund process. Please be aware that during peak seasons, high occupancy periods, trade fairs, and conventions, or if you fail to cancel your accommodation before the deadline specified in the confirmation email, the hotel may impose a penalty charge. If a penalty charge is applicable, it will be deducted from the refund amount.</span>
            <span>Your confirmation email will provide detailed information about the cancellation deadline, which you must adhere to in order to avoid any cancellation fees.</span>
            <span>Unless stated otherwise in the cancellation policy, cancellation requests submitted through any of the aforementioned methods before the deadline specified in the confirmation email will generally result in a full refund of the accommodation cost within 10 days of receiving the request (LETSFLY LIMITED does not charge a cancellation processing fee). Any cancellation requests submitted after the specified deadline will also be processed within 10 days, with any applicable penalty charge deducted from the refund amount.</span>
            <span>In most cases, refunds for shortened stays will be processed within 10 days, net of any applicable penalty charges. If you notify us (through any of the mentioned methods) before shortening your stay, we can expedite the refund process. However, if you notify us after checking out, some refunds for shortened stays may take longer, as some hotels may be slow to confirm the exact dates of your stay. If your refund is expected to take longer than 10 days, we will notify you via email upon receipt of your request.</span>
            <span>Please note: Many hotels will impose a penalty charge, often equivalent to one night's accommodation, for shortening your stay with late notice. Please carefully review the hotel policies.</span>
          </div>
        </div>
        <div class="policy-main" v-if="common.languageSet() === 'zh'">
          <div class="policy-title" v-if="common.isMobile() === false">退款政策</div>
          <div class="policy-content">
            <span>如需申请退款，请通过以下任一方式与我们联系：</span>
            <span>
              • 在我们的网站
              <!-- <a v-bind:href="weburl">{{ webhost }}</a> -->
              <router-link :to="weburl">
                {{ webhost }}
              </router-link>
              上申请
            </span>
            <span>• 通过电话 [+86-411-84949566]（适用国际通话）</span>
            <span>
              • 通过我们的
              <!-- <a v-bind:href="contactUsUrl">客户支持页面</a> -->
              <router-link :to="contactUsUrl">
                {{ webhost }}
              </router-link>
              发送电子邮件
            </span>
            <span>LETSFLY LIMITED 致力于为您提供简便高效的退款流程。请注意，在旺季、高入住率时期、贸易展会和大会期间，或者在未在确认邮件上注明的截止日期之前取消您的住宿，可能会导致酒店征收罚款。如果产生罚款，该费用将从退款金额中扣除。</span>
            <span>您的确认电子邮件将详细说明取消截止日期，您必须在此日期之前取消以避免产生罚款。</span>
            <span>除非取消政策另有明确说明，通过以上任一方式在确认邮件上注明的截止日期之前提交的取消请求通常将在收到请求后的10天内全额退还住宿费用（LETSFLY LIMITED 不收取取消处理费）。在确认邮件上注明的截止日期之后提交的任何取消请求也将在10天内处理，并将从退款金额中扣除任何适用的罚款。</span>
            <span>大多数情况下，退款将在10天内退回原银行账户。如果您在退房前通过以上任一方式通知我们，我们将加速退款流程。但如果您在退房后才提出申请，缩短入住时间的退款可能将会耗费较长时间，因为一些酒店确认您实际入住时间的过程需时较长。</span>
            <span>请注意：如未能及时告知缩短入住天数，多数酒店将收取罚款，通常相当于一晚住宿费。请仔细查阅酒店政策。</span>
          </div>
        </div>
    </el-main>
    <publicFooter></publicFooter>
  </el-container>
</template>

<script>
import { getContactInfo } from '@/request/question.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
export default {
  name: 'policy',
  components: {
    publicFooter,
    publicHeader
  },
  data () {
    return {
      source: 'roompai',
      webhost: '',
      weburl: '',
      contactUsUrl: '',
      customerEmail: { 0: '' },
      conver: ''
    }
  },
  mounted () {
    var source = this.common.linkQuerys.source
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      localStorage.removeItem('source')
      localStorage.removeItem('sourceExpiresAt')
    }
    let conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }

    // 获取 web host
    this.getWebHost()

    this.getContactInfo()
  },
  methods: {
    getContactInfo () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        source: this.source,
        time: time,
        sessionid: sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      getContactInfo(data).then((res) => {
        if (res.flag === '200') {
          this.customerEmail = res.data.customer_email
        }
      })
    },
    getWebHost: function () {
      this.webhost = location.host
      let weburl = {name: 'Home', params: {'querys': this.common.linkEncode({'source': this.source}, 'obj')}}
      let contactUsUrl = {name: 'contactUs', params: {'querys': this.common.linkEncode({'source': this.source}, 'obj')}}
      if (this.conver === 1 || this.conver === '1') {
        weburl = {name: 'Home', params: {'querys': this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')}}
        contactUsUrl = {name: 'contactUs', params: {'querys': this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')}}
      }
      this.weburl = weburl
      this.contactUsUrl = contactUsUrl
    },
    goback: function () {
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
        window.document.location.href = LoginWebsiteAddress
      } else {
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'Home', params: {'querys': newQuerys}})
      }
    }
  }
}
</script>

<style scoped>
/deep/ .top-pc {
  margin-top: 60px;
}

.policy-main {
  min-height: 840px;
  margin: 20px auto;
  color: rgba(0, 0, 0, 0.6470588235294118);
}

.policy-title {
  height: 60px;
  font-weight: 650;
  font-size: 18px;
  line-height: 60px;
}

.policy-content span {
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: block;
  margin-bottom: 20px;
}

@media screen and (min-width: 1001px) {
  .policy-main {
    width: 1100px;
  }
}

@media screen and (max-width: 1000px) {
  .policy-main {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/question/refundPolicy.vue